import request from '@/utils/request'

// 查询列表
export function selectPage(query) {
  return request({
    url: "/cw/account/getPage",
    method: "get",
    params: query
  });
}

// 删除
export function delData(id) {
  return request({
    url: "/cw/account/"+id,
    method: "delete"
  });
}

// 根据id查询
export function selectOne(id) {
  return request({
    url: "/cw/account/"+id,
    method: "get"
  });
}

// 新增
export function addData(data) {
  return request({
    url: "/cw/account",
    method: "post",
    data: data
  });
}

// 修改
export function updateData(data) {
  return request({
    url: "/cw/account",
    method: "put",
    data: data
  });
}

// 设为默认/取消
export function changeStatus(accountId,isDefault) {
  return request({
    url: "/cw/account/"+accountId+"/"+isDefault,
    method: "put"
  });
}
